module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Giro ")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "filterable": "",
      "clearable": "",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiro()
      }
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingMarking),
      expression: "isLoadingMarking"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columnsDataTable,
      "data": _vm.receivableGiroData
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "500px"
    },
    model: {
      value: (_vm.isModalAddGiro),
      callback: function($$v) {
        _vm.isModalAddGiro = $$v
      },
      expression: "isModalAddGiro"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#2d8cf0",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Tambah Giro")])], 1), _vm._v(" "), _c('Form', {
    ref: "formAddGiro",
    attrs: {
      "model": _vm.formAddGiro,
      "rules": _vm.ruleValidateGiro
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "Tanggal Invoice & No. Container",
      "prop": "invoiceDate"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formAddGiro.invoiceDateContainerNumber),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "invoiceDateContainerNumber", $$v)
      },
      expression: "formAddGiro.invoiceDateContainerNumber"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formAddGiro.receivableId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "receivableId", $$v)
      },
      expression: "formAddGiro.receivableId"
    }
  }), _vm._v(" "), _c('Input', {
    staticStyle: {
      "display": "none"
    },
    model: {
      value: (_vm.formAddGiro.markingHeaderId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "markingHeaderId", $$v)
      },
      expression: "formAddGiro.markingHeaderId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Terima Giro",
      "prop": "giroDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Terima Giro",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formAddGiro.giroDate),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "giroDate", $$v)
      },
      expression: "formAddGiro.giroDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nomor Giro",
      "prop": "giroNumber"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "Nomor Giro"
    },
    model: {
      value: (_vm.formAddGiro.giroNumber),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "giroNumber", $$v)
      },
      expression: "formAddGiro.giroNumber"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Nominal Giro",
      "prop": "giroNominal"
    }
  }, [_c('br'), _vm._v(" "), _c('money', _vm._b({
    staticClass: "ivu-input right",
    staticStyle: {
      "width": "150px"
    },
    model: {
      value: (_vm.formAddGiro.giroNominal),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "giroNominal", $$v)
      },
      expression: "formAddGiro.giroNominal"
    }
  }, 'money', _vm.money, false))], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Tanggal Jatuh Tempo",
      "prop": "paymentDate"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "200px",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Tanggal Jatuh Tempo",
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formAddGiro.paymentDate),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "paymentDate", $$v)
      },
      expression: "formAddGiro.paymentDate"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Bank",
      "prop": "bankAccountId"
    }
  }, [_c('br'), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "80%",
      "display": "revert"
    },
    attrs: {
      "placeholder": "Pilih Rekening Bank",
      "clearable": ""
    },
    model: {
      value: (_vm.formAddGiro.bankAccountId),
      callback: function($$v) {
        _vm.$set(_vm.formAddGiro, "bankAccountId", $$v)
      },
      expression: "formAddGiro.bankAccountId"
    }
  }, _vm._l((_vm.bankAccounts), function(bankAccount) {
    return _c('Option', {
      key: bankAccount.id,
      attrs: {
        "value": bankAccount.id
      }
    }, [_vm._v(_vm._s(bankAccount.accountName) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    attrs: {
      "type": "primary",
      "loading": _vm.isLoadingAddGiro
    },
    on: {
      "click": _vm.postAddGiro
    }
  }, [(!_vm.isLoadingAddGiro) ? _c('span', [_vm._v("Submit")]) : _c('span', [_vm._v("On process.....")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b1d850c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/Giro.vue
// module id = 1844
// module chunks = 1